<template>
    <v-dialog v-model="dialog" width="700" :fullscreen="isMobileOrTablet()" persistent>
        <v-card class="rounded-lg" style="display: flex; flex-direction: column; height: 100%;">
            <v-card-title style="background-color: #1a5b0f !important; display: flex; justify-content: space-between; align-items: center;">
                <div>
                    <span class="font-weight-bold text-h6 text-white">{{ dialog_title }}</span>
                    <div class="text-caption text-white">{{ dialog_sub_title }}</div>
                </div>
                <v-btn v-if="loading == false" flat icon color="darkGreen" @click="closeDialog()">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text style="overflow-y: auto; max-height: calc(100vh - 100px);">
                <v-form ref="form" class="mt-2">
                    <v-row dense>
                        <v-col cols="12">
                            <v-textarea
                                v-model="remarks"
                                :rules="[formRules.required]"
                                label="Remarks"
                                variant="outlined"
                                rounded="lg"
                                type="text"
                                color="darkGreen"
                                auto-grow
                                prepend-icon="mdi-comment"
                                autofocus
                                >
                            </v-textarea>
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions class="pa-3" style="margin-top: auto;">
                <v-spacer></v-spacer>
                <v-btn class="mr-1" :disabled="loading" text="Cancel" variant="outlined" elevation="1" @click="closeDialog()"></v-btn>
                <v-btn class="mr-1" :loading="loading" text="Save" variant="elevated" elevation="1" color="darkGreen" @click="validateForm()"></v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <v-dialog v-model="confirmReturn" width="450" persistent>
        <v-card color="secondary" rounded="lg" class="pa-2">
            <v-card-text>
                <div class="font-weight-bold mt-2 text-h6">Are you sure you want to return this compliance?</div>
                <div class="font-weight-light mt-2">Note: Once returned, remarks may not be updated. Please review your remarks information carefully before proceeding.</div>
            </v-card-text>
            <template v-slot:actions>
            <v-spacer></v-spacer>

            <v-btn @click="confirmReturn = false" :disabled="loading" variant="outlined">
                Cancel
            </v-btn>
            <v-btn :loading="loading" @click="returnCompliances()" color="darkGreen" variant="elevated">
                Confirm
            </v-btn>
            </template>
        </v-card>
    </v-dialog>
</template>

<script>
import { defineComponent } from 'vue'
import { useSnackbar } from '@/composables/useSnackbar'

export default defineComponent({
     emits: ["refresh"],
     data(){
        return {
            dialog: false,
            dialog_title: null,
            dialog_sub_title: null,
            action: null,
            loading: false,

            id: null,
            compliance_data: null,
            file_id: null,
            remarks: null,
            created_by: null,

            confirmReturn: false,
        }
     },
     methods: {
        initReturn(data){
            this.dialog = true
            this.dialog_title = 'Return with Remarks'
            this.dialog_sub_title = 'Add remarks to the returned compliances'
            this.action = 'return'

            this.file_id = data.file_id
            this.compliance_data = data
            this.created_by = this.$store.state.user.id
        },
        async returnCompliances(){
            const { showSnackbar } = useSnackbar()
            this.loading = true
            let formData = {
                id: this.id,
                file_id: this.file_id,
                compliance_data: this.compliance_data,
                remarks: this.remarks,
                created_by: this.created_by
            }

            let save = await this.axiosCall('/compliance-upload/returnForApprovalCompliances', 'post', formData, true)
            if (save && save.data.status == 200) {
                this.loading = false
                this.$emit('refresh')
                showSnackbar('Compliance successfully returned!')
                this.$refs.form.reset()
                this.confirmReturn = false
                this.dialog = false
            }
        },
        async validateForm(){
            const { valid } = await this.$refs.form.validate()

            if(valid){
                this.confirmReturn = true
            }
        },
        closeDialog(){
            this.$refs.form.reset()
            this.dialog = false
        }
     }
})
</script>

<style scoped>

</style>